import { render, staticRenderFns } from "./ReportCheckListActuality.vue?vue&type=template&id=55a2bf22&scoped=true&"
import script from "./ReportCheckListActuality.vue?vue&type=script&lang=js&"
export * from "./ReportCheckListActuality.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckListActuality.vue?vue&type=style&index=0&id=55a2bf22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a2bf22",
  null
  
)

export default component.exports
import {QBtn,QIcon,QTooltip,QCard,QCardSection,QItem,QItemLabel,QCardActions,QScrollArea,QItemSection,QTr,QTh,QTd,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn,QIcon,QTooltip,QCard,QCardSection,QItem,QItemLabel,QCardActions,QScrollArea,QItemSection,QTr,QTh,QTd}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
